import { render } from "./CustomerVoice.vue?vue&type=template&id=30e9d5f6"
import script from "./CustomerVoice.vue?vue&type=script&lang=js"
export * from "./CustomerVoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__